import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

var objOrders = [];
var shopItems = "";

function Orders(props) 
{
    const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [orders, setOrders] = useState([]);
  const [errors, setErrors] = useState({});
  const [loggedIn, setLoggedIn] = useState(window.localStorage.getItem('MuckS_LoginState'))
  console.log(loggedIn);


  const handleInputChange = (e) => {
    const { name, value } = e.target;


    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // Validate email
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    }

    // Validate password
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };


  const handleLogout = (e) =>
    {
        e.preventDefault();
        localStorage.removeItem('MuckS_LoginState');
        setLoggedIn(null);
        //navigate('../');
        setFormData({
            email: "",
            password: ""
          });
    }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Form is valid, you can submit or process the data here
      console.log("Form data:", formData);
      setLoggedIn(formData);
      localStorage.setItem('MuckS_LoginState', JSON.stringify(formData));
      setLoggedIn(formData);

      // Here set global state
    } else {
      // Form is not valid, display error messages
    }
  };
  function toOrderDetails(orderID)  {
    window.location = `https://mucksucker.com/orderDetails?order=${orderID}`;
  }

  const isFormValid = Object.keys(errors).length === 0;
  const getData = async () => {

    const response = await fetch('https://mucksucker.com:3001/getOrders', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body:  JSON.stringify({email: loggedIn})
    })
    const data = await response.json();
    objOrders = data;
    console.log(objOrders);
    const localShopItems = objOrders.map((order) =>
      {
        var objSalesData = JSON.parse(order.salesData);
        var strDate = order.created;
        var date = timeConverter(strDate);
        function timeConverter(UNIX_timestamp){
          var a = new Date(UNIX_timestamp * 1000);
          var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
          var year = a.getFullYear();
          var month = months[a.getMonth()];
          var date = a.getDate();
          var hour = a.getHours();
          var min = a.getMinutes();
          var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
          return time;
        }
        console.log(timeConverter(0));

        return <li className="orderListItem" onClick={() => toOrderDetails(order._id)} key= {order._id} dataid={order._id}>
          <div className="shopItemContainer">
            <div className="shopPriceContainer">
              <p className="shopListPrice"> £{(order.amount/100).toFixed(2)}</p>
            </div>

            <p>{date}</p>
          </div>
        </li> 
      }
    )

    setOrders(localShopItems);
  }

  useEffect(()  => {

    getData();

  }, []);
  return (
    <div className="container">
      <h2>Orders</h2>
      {loggedIn ? (
        <div className="success-message"><p>You are Logged in Here are your orders</p>
            <ul className="shopListUl">
              {orders}
            </ul>
            <div onClick={handleLogout}><p>Logout</p></div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div>
            <label>Email:</label>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            {errors.email && <div className="error">{errors.email}</div>}
          </div>

          <div>
            <label>Password:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
            />
            {errors.password && <div className="error">{errors.password}</div>}
          </div>

          <button type="submit" disabled={!isFormValid}>
            Login
          </button>
        </form>
      )}
    </div>
  );
}

export default Orders;